import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { AlertService } from "src/@core/services/alert.service";

@Injectable()
export class RateLimitInterceptor implements HttpInterceptor {
  private readonly legacyRateLimitMessage =
    "Too many concurrent requests. Please retry shortly.";
  private readonly rateLimitMessage = "Server is busy. Please retry shortly.";

  constructor(private readonly alertService: AlertService) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      tap({
        error: (err) => {
          if (Number(err?.status) === 429) {
            this.alertService.serverBusy(this.getRateLimitMessage(err));
          }
        },
      })
    );
  }

  private getRateLimitMessage(err: any): string {
    const message = this.getMessageFromBody(err?.error);

    if (!message || message === this.legacyRateLimitMessage) {
      return this.rateLimitMessage;
    }

    return message;
  }

  private getMessageFromBody(body: any): string | null {
    if (!body) {
      return null;
    }

    if (typeof body === "string") {
      const trimmed = body.trim();
      if (!trimmed) {
        return null;
      }

      try {
        return this.getMessageFromBody(JSON.parse(trimmed)) || trimmed;
      } catch {
        return trimmed;
      }
    }

    const candidate =
      body.message ||
      body.Message ||
      body.title ||
      body.Title ||
      body.detail ||
      body.Detail ||
      body.error;

    return typeof candidate === "string" && candidate.trim()
      ? candidate.trim()
      : null;
  }
}
